<!--
     <FieldUser>
-->

<template>
  <span class="d-flex" v-if="field.props.value">
    <div>
      <v-menu
        :value="menu"
        content-class="white"
        :close-on-content-click="false"
        @input="update_menu"
      >
        <template v-slot:activator="{on, attrs}">
          <v-avatar
            v-if="!image_error && user_avatar && !hide_avatar && !field.props.hide_avatar"
            v-bind="attrs"
            v-on="on"
            size="24px"
            class="mr-2"
            @click.stop
          >
            <img
              :src="user_avatar"
              class="username-picture"
              @error="error_loading"
            />
          </v-avatar>
          <span v-bind="attrs" v-on="on">{{ representation }}</span>
        </template>

        <v-list dense class="overflow-y-auto" two-line v-if="user">
          <v-list-item
            v-for="contact in [user]"
            :key="contact.value"
          >
            <v-list-item-avatar color="primary" :size="32">
              <v-img 
                v-if="contact.photo"
                :src="contact.photo">
              </v-img>
              <span
                v-else
                color="primary"
              >
                {{ contact.initials }}
              </span>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="contact.title"></v-list-item-title>
              <v-list-item-subtitle v-text="contact.role"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <TooltipButton
                custom_icon="mdi-cellphone"
                color="primary"
                :tooltip_text="$t('copied')"
                @click="copyToClipboard(contact.phone)"
              />
            </v-list-item-action>
            <v-list-item-action>
              <TooltipButton
                custom_icon="mdi-email-outline"
                color="primary"
                :tooltip_text="$t('copied')"
                @click="copyToClipboard(contact.email)"
              />
            </v-list-item-action>              
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </span>
</template>

<style lang="scss">
</style>

<script>
  import TooltipButton from '@/components/TooltipButton';
  import { resolve_image } from '@/utils/logos';
  export default {
    name: 'FieldUser',

    components: {
      TooltipButton
    },

    props: {
      unit: {default: () => ({})},
      field: { required: true },
      hide_avatar: Boolean,
    },
    data() {
      return {
        menu: false,
        image_error: false,
      }
    },

    computed: {
      representation() {
        return ''+this.field;
      },

      user() {
        return this.unit.contacts.find(it => it.value == this.field.props.value);
      },
      
      user_avatar() {
        return this.user && this.user.photo ? resolve_image(this.user.photo) : "";
      }
    },

    methods: {
      update_menu(menu) {
        this.menu = menu;
      },

      copyToClipboard(textToCopy)  {
        navigator.clipboard.writeText(textToCopy || " ");
      },

      error_loading(error) {
        this.image_error = error;
      }
    },
  }
</script>